import React, { useEffect, useState } from "react";
import { Button, InputDisable, Select, EditCard, BackNextButton, AddButton, Modal, } from "../../../../../common";
import { ReactComponent as Pen } from "../../../../../../assets/images/companyIcons/pen.svg";
import { ReactComponent as AddressIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/address.svg";
import { ReactComponent as HoursIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/hours.svg";
import { ReactComponent as EmailIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/email.svg";
import { ReactComponent as TelephoneIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/telephone.svg";
import { EditCardItems } from "../EditCardItems";
import { NewAddressForm } from "./NewAddressForm";
import { useSelector, useDispatch } from "react-redux";
import { createAddress } from "../../../../../../utils/Helper";
import { useGetCompanyQuery, useAddressdetailsdraftFetchMutation, useCreateAddressDetailsUpdateMutation, useDeleteAddressDetailsDraftMutation } from "../../../../../../store/Company/companyApiSlice";
import { setCurrentEditingCompany } from "../../../../../../store/Company/companySlice";
import { ReactComponent as Delete } from "../../../../../../assets/images/companyIcons/delete1.svg"
import { ReactComponent as Verified } from "../../../../../../assets/icons/verified.svg";
import { ReactComponent as Declined } from "../../../../../../assets/icons/cancel.svg";
import { ReactComponent as Requested } from "../../../../../../assets/icons/pending.svg";
import { ReactComponent as Skipped } from "../../../../../../assets/icons/review.svg";
export const AddressContact = ({ onPrev, onNext, onSkip, handleUpdateStatus }) => {
  const dispatch = useDispatch();
  const [addresses, setAddress] = useState([]);
  const [addressesDraft, setAddressDraft] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [editAddress, setEditAddress] = useState(null);
  const [primaryAddress, setPrimaryAddress] = useState(null);
  const { currentEditingCompany } = useSelector((state) => state.company);
  const [Addressdetailsdraft] = useAddressdetailsdraftFetchMutation();
  const { token } = useSelector((state) => state.auth);
  const [addressDetailsUpdate] =
    useCreateAddressDetailsUpdateMutation();
  const [deleteDraft] = useDeleteAddressDetailsDraftMutation()

  const { data, refetch } = useGetCompanyQuery({
    companyId: currentEditingCompany?.companyID,
    token,
  });
  const [verifiedCompany, setverifiedCompany] = useState(false);

  useEffect(() => {
    if (data) {
      dispatch(setCurrentEditingCompany(data));
    }
  }, [data, dispatch]);
  const companyStatus = async () => {
    let dataval = await Addressdetailsdraft({
      companyID: currentEditingCompany?.companyID,
      token,
    });
    if (dataval?.data?.data) {
      let respData = dataval?.data?.data;
      let tempArr = [];
      let draft_ids = [];
      let ids = [];
      let main_ids = [];
      for (let i = 0; i < respData.length; i++) {
        draft_ids.push(respData[i]?.company_address_detailsID_id);
        tempArr.push(respData[i]);
      }
      addresses.forEach(function (obj) {
        if (obj?.company_address_detailsID?.is_deleted == 0) {
          ids.push(obj?.company_address_detailsID?.company_address_detailsID)
        }
      });
      ids.forEach(function (id) {
        if (!draft_ids.includes(id))
          main_ids.push(id)
      })
      addresses.forEach(function (obj) {
        if (obj?.company_address_detailsID?.is_deleted == 0) {

          if (main_ids.includes(obj?.company_address_detailsID?.company_address_detailsID)) {
            tempArr.push(obj?.company_address_detailsID)
          }
        }
      });
      setAddressDraft(tempArr)
    }

  }
  const modalHandleDelete = async (deleteInfo) => {
    if (deleteInfo?.company_address_details_draftID) {
      let dataval = await deleteDraft({
        data: deleteInfo?.company_address_details_draftID,
      });
      if (dataval?.data == null) {
        alert("Address Details Deleted Successfully");
        window.location.reload()
      }
    } else if (deleteInfo?.company_address_detailsID) {
      let res = await addressDetailsUpdate({
        data: { is_deleted: 1 },
        company_address_detailsID: deleteInfo?.company_address_detailsID,
        token,
      }).unwrap();
      if (res?.is_deleted == 1) {
        handleUpdateStatus()
        alert("Address Details Deleted Successfully");
        window.location.reload()
      }
    }
  }
  useEffect(() => {
    if (!currentEditingCompany) return;
    if (currentEditingCompany && currentEditingCompany?.verifiedCompany) {
      setverifiedCompany(true)

    }
    let resultArr = [];
    let Dettemp = currentEditingCompany?.companyAddress?.forEach(function (obj) {
      if (obj?.company_address_detailsID?.is_deleted == 0) {
        resultArr.push(obj)
      }
    });
    setAddress(resultArr);
    companyStatus();
  }, [currentEditingCompany]);

  const modalHandle = (address, primaryAddress) => {
    setEditAddress(address);
    setPrimaryAddress(primaryAddress);
    setIsOpen(!isOpen);
    refetch();
    companyStatus()
  };

  function createArrayFromObject(object) {
    let otherData = ["email", "working_hours", "telephone"];
    let icons = {
      email: <EmailIcon />,
      working_hours: <HoursIcon />,
      telephone: <TelephoneIcon />,
      address: <AddressIcon />,
    };

    let data = [];

    for (let key in object) {
      if (otherData.includes(key)) {
        data.push({ [key]: object[key], icon: icons[key] });
      }
    }
    const address = createAddress(object);
    data.push({ address, icon: icons["address"] });

    let keyValuePairs = data.map((item) =>
      Object.entries(item).map(([key, value]) => [key, value])
    );

    let html = keyValuePairs.map((item) => (
      <EditCardItems
        heading={item[0][0]?.replace("_", " ")}
        subHeading={item[0][1]?.replace("|", "")}
        icon={item[1][1]}
      />
    ));
    return html;
  }

  return (
    <div className="mt-5 mr-20 ">
      {isOpen && (
        <Modal modalHandle={modalHandle}>
          <NewAddressForm
            address={editAddress}
            primaryAddress={primaryAddress}
            modalHandle={modalHandle}
            refetch={refetch}
            edit={editAddress}
          />
        </Modal>
      )}
      <h3 className="text-f20 font-semibold text-secondarytwo text-left mb-2">
        Address & Contact Information
      </h3>

      <div className="border border-slate rounded-lg p-8 mb-6">
        {addressesDraft.length <= 0 && addresses.length <= 0 && <AddButton
          text="Add New Address & Contact information"
          buttonText="Add"
          onClick={() => modalHandle(null)}
        />}
        <div className="grid grid-cols-2 gap-4">
          {addressesDraft.length <= 0 && addresses.map((item) => (
            <EditCard key={item.company_address_detailsID} item={item}>
              <div className="statusSection">
                {item.company_address_detailsID.status === "Verified" && (
                  <Verified />
                )}
                {item.company_address_detailsID.status === "Declined" && (
                  <Declined />
                )}
                {item.company_address_detailsID.status === "Skipped" && (
                  <Skipped />
                )}
                {(item.company_address_detailsID.status === "Requested" || item.company_address_detailsID.status === "raised") && (
                  <Requested />
                )}
              </div>
              <div className="h-[17rem] overflow-y-auto relative  my-2">
                {createArrayFromObject(item.company_address_detailsID)}
              </div>
              <div className="actionseditDelete  gap-4">

                <Button
                  onClick={() =>
                    modalHandle(
                      item.company_address_detailsID,
                      item.primary_address
                    )
                  }
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                >
                  <span>Edit Details</span>
                  <span>
                    <Pen />
                  </span>
                </Button>
                {/* <Button
                  onClick={() => modalHandleDelete(item?.company_address_detailsID)}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                >
                  <span>Delete</span>
                  <span>
                    <Delete />
                  </span>
                </Button> */}
              </div>
            </EditCard>
          ))}
          {addressesDraft.map((item) => (
            <EditCard key={item.company_address_details_draftID} item={item}>
              <div className="statusSection">
                {item.status === "Verified" && (
                  <Verified />
                )}
                {item.status === "Declined" && (
                  <Declined />
                )}
                {item.status === "Skipped" && (
                  <Skipped />
                )}
                {(item.status === "Requested" || item.status === "raised") && (
                  <Requested />
                )}
              </div>
              <div className="h-[17rem] overflow-y-auto relative  my-2">
                {createArrayFromObject(item)}
              </div>
              <div className="actionseditDelete  gap-4">

                <Button
                  onClick={() =>
                    modalHandle(
                      item
                    )
                  }
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                >
                  <span>Edit Details</span>
                  <span>
                    <Pen />
                  </span>
                </Button>
                {/* <Button
                  onClick={() => modalHandleDelete(item)}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                >
                  <span>Delete</span>
                  <span>
                    <Delete />
                  </span>
                </Button> */}
              </div>
            </EditCard>
          ))}
        </div>
      </div>
      <BackNextButton
        onPrev={() => onPrev(1, "Industry", "About")}
        onNext={() => onNext(3, "Social Media", "About")}
        onSkip={() => onSkip(3, "Social Media", "About")}
        isLoading={false}
      />
    </div>
  );
};
